
import React, { Suspense, lazy } from 'react';
import ReactOnRails from 'react-on-rails/client';
import { createRoot } from 'react-dom/client';

// Eager: used on most pages (header/footer) or very small.
import Header from 'bundles/Aplication/components/Header';
import AudioPlayer from 'bundles/Components/AudioPlayer';

const lazyComponent = (Component) => (props) =>
  React.createElement(
    Suspense,
    {
      fallback: React.createElement('div', {
        className: 'loading-placeholder',
        style: { minHeight: '100px' },
      }),
    },
    React.createElement(Component, props)
  );

const LoadGoogleAd = lazy(() => import('bundles/Aplication/components/LoadGoogleAd'));
const CommerceSlides = lazy(() => import('bundles/Commerce/CommerceSlides'));
const EpisodePlayer = lazy(() => import('bundles/Components/EpisodePlayer'));
const EpisodePlaylist = lazy(() => import('bundles/Components/EpisodePlaylist'));
const GrandstandVideo = lazy(() => import('bundles/Components/GrandstandVideo'));
const GrandstandVoice = lazy(() => import('bundles/Components/GrandstandVoice'));
const Playlist = lazy(() => import('bundles/Components/Playlist'));
const Share = lazy(() => import('bundles/Components/Share'));
const ShowMore = lazy(() => import('bundles/Components/ShowMore'));
const VideoPlayer = lazy(() => import('bundles/Components/VideoPlayer'));
const OttHeader = lazy(() => import('bundles/Components/ott/OttHeader'));
const StreamingHeader = lazy(() => import('bundles/Components/ott/StreamingHeader'));
const VideoHeader = lazy(() => import('bundles/Components/ott/VideoHeader'));
const PlayerControls = lazy(() => import('bundles/Components/PlayerControls'));
const Programs = lazy(() => import('bundles/Components/Programs'));
const StationSelect = lazy(() => import('bundles/Components/StationSelect'));
const Stories = lazy(() => import('bundles/Components/Stories'));

// This is how react_on_rails can see the HelloWorld in the browser.
//
// We need to "register" all components in here
//
// Let's use alphabetical order
ReactOnRails.register({
  Header,
  AudioPlayer,

  PlayerControls,
  CommerceSlides,
  VideoPlayer,
  EpisodePlayer,
  GrandstandVideo,
  GrandstandVoice,
  LoadGoogleAd,
  OttHeader,
  StreamingHeader,
  VideoHeader,
  EpisodePlaylist,
  Playlist,
  Share,
  ShowMore,
  StationSelect,
  Stories,
  Programs
});

// We store the 'root' object globally so we don't recreate it
let audioRoot = null;

document.addEventListener("turbo:load", () => {
  const container = document.getElementById('audio-player-permanent-root');
  
  // Only initialize if the container exists and we haven't created a root yet
  if (container && !audioRoot) {
    const lottiePath = container.dataset.lottiePath;
    
    // 1. Create the React root
    audioRoot = createRoot(container);
    
    // 2. Render the component
    audioRoot.render(
      <AudioPlayer lottie={lottiePath} />
    );
  }
});